<h2>Dwuskładnikowe uwierzytelnianie</h2>
<p>Jeśli przed chwilą skonfigurowałeś 2FA w Keycloak, możesz się teraz zalogować.</p>
<p>Za moment wrócimy na ekran logowania…</p>
<button (click)="router.navigate(['/login'])">Przejdź teraz</button>
